import React, { useState } from 'react';
import { IitemPedido } from '../../../interfaces/itemPedido';

interface FormItemPedidoProps {
    pedidoId: string;
    item?: IitemPedido; // Para caso de edição, um item pode ser passado
    onSubmit: (item: IitemPedido) => void;
}

const FormItemPedido: React.FC<FormItemPedidoProps> = ({ pedidoId, item, onSubmit }) => {
    const [formData, setFormData] = useState<IitemPedido>({
        pedidoId: pedidoId,
        descricao: item?.descricao || '',
        unidade: 'Peça',
        quantidade: item?.quantidade || 1,
        valorUnidade: item?.valorUnidade || 0,
        valorTotal: item?.valorTotal || 0
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let newFormData = {
            ...formData,
            [name]: name === 'quantidade' || name === 'valorUnidade' ? Number(value) : value
        };

        // Recalcula o valor total em tempo real
        if (name === 'quantidade' || name === 'valorUnidade') {
            const quantidade = name === 'quantidade' ? Number(value) : formData.quantidade;
            const valorUnidade = name === 'valorUnidade' ? Number(value) : formData.valorUnidade;
            newFormData.valorTotal = quantidade * valorUnidade;
        }

        setFormData(newFormData);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (pedidoId !== '') {
            onSubmit(formData);
            // Reseta o formulário após o envio
            setFormData({
                pedidoId: pedidoId,
                descricao: '',
                unidade: 'Peça',
                quantidade: 1,
                valorUnidade: 0,
                valorTotal: 0
            });
        }
    };

    return (
        <form onSubmit={handleSubmit} className='form-item-pedido'>
            <div>
                <label>Pedido:</label>
                <input
                    type="text"
                    name="pedidoId"
                    value={item?.pedidoId || pedidoId}
                    onChange={handleChange}
                    readOnly
                    required
                />
            </div>

            <div>
                <label>Descrição:</label>
                <input
                    type="text"
                    name="descricao"
                    value={formData.descricao}
                    onChange={handleChange}
                    required
                />
            </div>

            {/* <div>
                <label>Unidade R$:</label>
                <input
                    type="text"
                    name="unidade"
                    value={'Peça'}
                    onChange={handleChange}
                    required
                />
            </div> */}

            <div>
                <label>Quantidade:</label>
                <input
                    type="number"
                    name="quantidade"
                    value={formData.quantidade}
                    onChange={handleChange}
                    min="1"
                    required
                />
            </div>

            <div>
                <label>Valor por Unidade R$:</label>
                <input
                    type="number"
                    name="valorUnidade"
                    value={formData.valorUnidade}
                    onChange={handleChange}
                    min="0"
                    step="0.01"
                    required
                />
            </div>

            <div>
                <label>Valor Total:</label>
                <input
                    type="number"
                    name="valorTotal"
                    value={formData.valorTotal}
                    readOnly
                />
            </div>

            <button type="submit">Salvar Item</button>
        </form>
    );
};

export default FormItemPedido;
